/**
 * 获取文章里的缩略图
 * */
export const getThumbnail = (data) => {
    const image = data.thumbnails.image && data.thumbnails.image[0] && data.thumbnails.image[0].url;

    return image || '';
};

/**
 * 添加前置0
 * */
export const addZero = (str, targetLength = 2) => {
    return str.length < targetLength ? `0${str}` : str.toString();
};
